import React, { useState } from 'react';
import PropTypes from 'prop-types';
import {
    Button,
    Col,
    Container,
    Input,
    InputGroup,
    InputGroupText,
    Row,
} from 'reactstrap';
import TermsOfUse from '../../../components/legal/termsOfUse';
import '../css/acceptTermsOfUse.css'

interface AcceptTermsOfUseProps {
    onSubmit: Function;
    onCancel: Function;
}
const AcceptTermsOfUse: React.FC<AcceptTermsOfUseProps> = ({ onSubmit, onCancel }) => {
    const [isAccepted, setIsAccepted] = useState<any>(false);

    const handleCheckboxChange = (event: any) => {
        const { checked } = event.target;
        setIsAccepted(checked);
    }

    const save = (event: any) => {
        event.preventDefault();
        onSubmit(isAccepted);
    }

    const cancel = (event: any) => {
        event.preventDefault();
        onCancel(event);
    }

    const acceptanceVerbiage: React.CSSProperties = {
        marginLeft: '10px',
        backgroundColor: 'transparent',
        border: 'none',
    };

    return (
        <div style={{ marginBottom: '30px' }}>
            <Container>
                <Row>
                    <Col>
                        <p className="text-center fw-bold header-text" >MyHealthDirect Terms of Use</p>
                        <hr></hr>
                        <TermsOfUse />
                    </Col>
                </Row>
                <div className="d-flex flex-row-reverse">
                    <div className="p-2">
                        <InputGroup>
                            <Input addon type="checkbox" name="isAccepted" value={isAccepted} onChange={handleCheckboxChange} />
                            <InputGroupText style={acceptanceVerbiage}>I have read and accept the Terms of Use</InputGroupText>
                            <Button className='spacing' color="primary" onClick={save} disabled={!isAccepted}>Save</Button>
                            <Button className='spacing' onClick={cancel}>Cancel</Button>
                        </InputGroup>
                    </div>
                </div>
            </Container>
        </div>
    )
}
export default AcceptTermsOfUse;